/**
 * 기기 감지 (SR-OPS-05 · FS-01-01 "기기 감지 결과(비가시)").
 * WebGL2·WebAssembly 가 없으면 FE-601(FS-C1-04). SharedArrayBuffer 가 없으면 복사 경로로 자동 전환
 * (SR-LCL-01)하므로 오류가 아니다. WebGPU 는 감지 시에만 선택 가속.
 */
export interface DeviceSupport {
  webgl2: boolean;
  wasm: boolean;
  sharedArrayBuffer: boolean;
  webgpu: boolean;
}

export function detectDevice(): DeviceSupport {
  let webgl2: boolean;
  try {
    webgl2 = !!document.createElement("canvas").getContext?.("webgl2");
  } catch {
    webgl2 = false;
  }
  return {
    webgl2,
    wasm: typeof WebAssembly === "object" && typeof WebAssembly.instantiate === "function",
    sharedArrayBuffer:
      typeof SharedArrayBuffer === "function" && globalThis.crossOriginIsolated === true,
    webgpu: typeof navigator !== "undefined" && "gpu" in navigator,
  };
}

export function isSupported(d: DeviceSupport): boolean {
  return d.webgl2 && d.wasm;
}
